import { Grid, Typography } from "@material-ui/core";
import { Card } from "@material-ui/core";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import useCustomState from "../../hooks/State";
import Type from "./Type";
import { useMountAPI } from "../../hooks/APICall";
import { useDispatch } from "react-redux";
import Call from "../../service/API";
import { useHistory } from "react-router";
import {
  SetCounterTypes,
  UpdateCounterTypes,
  UpdateShowCounterTypeListMode,
} from "../../store/actions";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  BLACK,
  BLUE_COLOR,
  DARK_SIDEBAR,
  ERROR_COLOR,
  GREEN_PRIMRY,
  ORANGE_COLOR,
  SILVER_TABLE_COLOR,
  counterTypesPageSize, // for pagination
  WHITE,
} from "../../utils/const";
import TableRecord from "./TableRecord";
import Loading from "../loading"; // for loading
import Paginator from "../paginator"; // for pagination

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ListCounterTypes = (props) => {
  const expanded = useCustomState(true);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  const pureCounterTypes = useSelector((state) => state.counterTypes);
  const updateCounterTypes = useSelector(
    (state) => state.updateCommands.updateCounterTypes
  );

  const showTableListMode = useSelector(
    (state) => state.componentStates.showCounterTypeTableMode
  );

  const isLoading = useCustomState(true);
  const allItems = useCustomState(0); // for pagination
  const selectedPage = useCustomState(1); // for pagination

  const dispatch = useDispatch();
  const history = useHistory();

  const utils = {
    page: selectedPage.value, // for pagination
    count: counterTypesPageSize, // for pagination
    typeName: "",
    typeDate: "",
    isLoading: isLoading,
    dispatch: dispatch,
    history: history,
    allItems: allItems, // for pagination
  };

  useMountAPI(fetchCounterTypes, utils);

  // for pagination
  const selectedPageChanged = (newPage) => {
    if (newPage !== selectedPage.value) {
      selectedPage.handleChange(newPage);
      utils.page = newPage;
      isLoading.handleChange(true);
      fetchCounterTypes(utils);
    }
  };

  const counterTypes = useCustomState([]);

  useEffect(() => {
    if (!isLoading.value) {
      counterTypes.handleChange(processCounterTypes(pureCounterTypes));
    }
  }, [isLoading.value]);

  useEffect(() => {
    if (updateCounterTypes) {
      isLoading.handleChange(true);
      fetchCounterTypes(utils);
    }
  }, [updateCounterTypes]);

  const showTableListModeChanged = (e) => {
    dispatch(
      UpdateShowCounterTypeListMode({
        showCounterTypeTableMode: e.target.checked,
      })
    );
  };

  const renderCardView = () => {
    return (
      <>
        {counterTypes.value.map((type, idx) => {
          return <Type data={type} key={idx} index={idx} />;
        })}
      </>
    );
  };

  const renderTableView = () => {
    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead style={{ backgroundColor: DARK_SIDEBAR, color: WHITE }}>
            <TableRow>
              <TableCell style={{ color: WHITE }}>#</TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                نوع کنتور
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                دسته
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                پروژه ها
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                کنتورها
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                تاریخ ثبت
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                جزئیات
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {counterTypes.value.map((type, idx) => {
              return (
                <TableRecord
                  idx={idx}
                  type={type}
                  pageSize={counterTypesPageSize}
                  pageNumber={selectedPage.value}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const renderView = () => {
    if (showTableListMode) {
      return renderTableView();
    } else {
      return renderCardView();
    }
  };

  const renderHeaderOptions = () => {
    return (
      <>
        <Grid
          item
          style={{
            paddingRight: "8px",
            paddingLeft: "8px",
            marginBottom: "24px",
          }}
          sx={12}
          sm={12}
          md={12}
          lg={12}
        >
          <Grid
            style={{ fontSize: "14px", color: "#73879c" }}
            container
            direction="row"
            alignItems="center"
          >
            <Grid style={{ marginLeft: "2px" }} item>
              <Checkbox
                onChange={showTableListModeChanged}
                color="primary"
                checked={showTableListMode}
              />
            </Grid>
            <Grid item>
              <span style={{ fontWeight: "bold" }}>نمایش جدولی</span>
            </Grid>
          </Grid>
        </Grid>
        <div
          style={{
            width: "100%",
            marginBottom: "24px",
            border: "1px solid #333",
          }}
        ></div>
      </>
    );
  };

  const renderPaginator = () => {
    {
      /* 
            begin: for pagination
          */
    }
    return (
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Grid container>
          <Paginator
            selectedPage={selectedPage.value}
            items={allItems.value}
            pageSize={counterTypesPageSize}
            selectedPageChanged={selectedPageChanged}
          />
        </Grid>
      </Grid>
    );
    {
      /* end: for pagination */
    }
  };

  const renderLoading = () => {
    {
      /* 
        begin: for loading
      */
    }
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ height: "260px", position: "relative" }}
      >
        <Loading />
      </Grid>
    );
    {
      /* end: for loading */
    }
  };

  // for loading and pagination
  const renderContent = () => {
    if (!isLoading.value) {
      return (
        <>
          <Grid item sx={12} sm={12} md={12} lg={12}>
            <Grid container>{renderView()}</Grid>
          </Grid>
        </>
      );
    } else {
      return renderLoading();
    }
  };

  return (
    <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Card
          style={{ width: "100%", marginTop: "16px", marginBottom: "16px" }}
        >
          <CardHeader
            style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
            title={"لیست انواع کنتورها"}
            action={
              <ExpandMoree
                expand={expanded.value}
                onClick={handleExpandClick}
                aria-expanded={expanded.value}
                aria-label="show more"
              >
                <ExpandMore />
              </ExpandMoree>
            }
          />
          <Collapse in={expanded.value} timeout="auto" unmountOnExit>
            <CardContent
              style={{
                padding: "16px",
              }}
            >
              <Grid container>
                {renderHeaderOptions()}
                {renderContent()}
                {renderPaginator()}
              </Grid>
            </CardContent>
          </Collapse>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ListCounterTypes;

const processCounterTypes = (counterTypes) => {
  const results = [];
  let data;
  counterTypes.map((counterType) => {
    data = {
      id: counterType.water_meter_type_id,
      name: counterType.water_meter_type_name,
      projects: counterType.All_project_with_this_type,
      counters: counterType.All_counter_with_this_type,
      category: counterType.water_meter_tag.water_meter_tag_name,
      date: counterType.water_meter_type_create_date,
      images: counterType.water_meter_type_files,
    };
    results.push(data);
  });
  return results;
};

const fetchCounterTypes = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const typeName = utils.typeName;
  const typeDate = utils.typeDate;
  const isLoading = utils.isLoading;
  const dispatch = utils.dispatch;
  const history = utils.history;
  const allItems = utils.allItems; // for pagination

  const data = {
    page: page,
    count: count,
    water_meter_type_name: typeName,
    water_meter_type_create_date: typeDate,
  };

  Call("POST", "WaterMeterTypes/admin/getAll", data)
    .then((response) => {
      // console.log("counterTypes", response);
      if (response.data.code == 200) {
        const types = response.data.data.results;
        allItems.handleChange(response.data.data["All_type's"]);
        // /* begin: for pagination */
        // if (types && types.length !== 0) {
        //   // allItems.handleChange(types[0]["all projects"]);
        // }
        // /* end: for pagination */
        dispatch(SetCounterTypes(types));
        dispatch(UpdateCounterTypes({ updateCounterTypes: false }));
      }
      // console.log(response);
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code == 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};
